<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" id="pop_skinCare" style="display: block">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">나의 스킨케어코드 조회</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <dl class="rew19_select_table">
          <dt>
            <span class="rew19_table_tit">총 {{$fmt.PDCnt(viewData.assCdList.length)}}개</span>
          </dt>
          <dd v-if="!(viewData.assCdList.length > 0)">
            <p class="rew19_noData">데이타가 존재하지 않습니다.</p>
          </dd>
          <dd v-else-if="viewData.assCdList.length > 0">
            <ul 
              v-for="(item, idx) in viewData.assCdList"
              v-bind:key="item.id"
              class="rew19_table_form skinCare">
              <li class="o1">
                <div class="rew19_wrapRadio_t1">
                  <input type="radio" class="rew19_fakeRadio_t1"
                    name="skinCareCode" 
                    :id="'skinCareCodeRadio_'+idx"
                    :value="item"
                    v-model="selectedSkinCode"
                  >
                  <label :for="'skinCareCodeRadio_'+idx"></label>
                </div>
              </li>
              <li class="o2">
                  <em class="rew19_tit">{{item.assessmentCode}}</em>
                  <span class="rew19_people">{{item.personName}}</span>
                  <p>{{item.assessmentLabel}}</p>
              </li>
              <li class="o3">
                  <span class="rew19_date">{{item.assessmentDate}}</span>
              </li>
            </ul>
          </dd>
          <dd v-if="viewData.assCdList.length <= 0">
            <ul
              class="rew18_table_form skinCare"
            >저장된 스킨 케어 코드가 없습니다. 피부 평가 앱을 통해 평가 진행 후 스킨 케어 코드를 저장하시면 주문 시 코드 불러오기를 할 수 있습니다.</ul>
          </dd>          
        </dl>
        <ul class="rew19_dotList skinCare">
          <li>코드 : [내 코드 가져오기]를 통해 선택하거나 스킨케어 코드 6자리를 직접 입력할 수 있습니다.</li>
          <li>코드별명 : [내 코드 가져오기]를 통해 선택하거나 원하는 코드 별명을 직접 입력할 수 있습니다.  (예) 홍길동의 스킨케어</li>
          <li>이름과 스킨 케어코드, 코드 별명이 인쇄된 라벨이 커스텀 프러덕트 세트의 상자 겉면에 부착되어 배송됩니다.</li>
        </ul>
      </div><!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div>
    </div>
  </div>  
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: 'SkinCareCodeListDialog',  
  components: {  },
  props: {
    show: {
      type: Boolean,
      default: false
    }    
  },
  data() {
    return {      
      currentZIndex : 2000,

      paramData :{
        memberId : null,
      },

      viewData : {
        assCdList : [
          // {
          //   assessmentCode: "M6FG8P",
          //   assessmentDate: "2019-10-08",
          //   assessmentLabel: "베이직 스킨케어 세트",
          //   id: -1,
          //   personName: "관리자",
          // }
        ]
      },

      selectedSkinCode : null,
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;
  },  
  methods :{
    onClose(response) {
      let _this = this;

      _this.$emit('close', response, response ? _this.selectedSkinCode : null);
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      let _this = this;
      if(!_this.selectedSkinCode){
        _this.$dialogs.alert("스킨케어코드를 선택해 주십시오.").then(res => {});   
        return;
      }

      _this.onClose(true);
    },

    /**
     * API Request
     */    
    //스킨코드 가져오기
    apiGetSkinCareCode(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_agelocme_skincode`, {
        params: {
          memberId: _this.paramData.memberId
        }        
      });
    },

    /**
     * Local 
     */
    initData(paramData){
      let _this = this;

      _this.paramData = paramData;
      
      _this.loadData();
    },

    loadData(){
      let _this = this;

      _this.$showLoading();      
      _this.apiGetSkinCareCode().then(res=>{
        
        let isSuccess = false;
        if(res.status === 200){
          res.data = JSON.parse(_this.$parseNuskinApiRes(res.data));

          if(res.data.result === "1") {
            _this.viewData = res.data;            
            isSuccess = true;
          }
        }
        
        if(!isSuccess){
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;

          _this.$dialogs.alert(errMsg)
          .then(res => {});      
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },
  }
}
</script>
<style>
a.del{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/SkinCareCodeListDialog.vue